import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  badge?: string;
  action?: string;
  permission?: string;
}

interface MenuSection {
  title: string;
  items: MenuItem[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  menuSections: MenuSection[] = [
    {
      title: 'Main',
      items: [
        { label: 'Dashboard', icon: 'dashboard', route: '/dashboard' },
        { label: 'Laporan CC', icon: 'report', route: '/laporan-cc' },
        // { label: 'My Balance', icon: 'balance', route: '/my-balance' }
      ]
    },
    {
      title: 'Management',
      items: [
        { label: 'Companies', icon: 'company', route: '/companies', permission: 'company.list' },
        { label: 'Users', icon: 'users', route: '/users', permission: 'user.list' },
        { label: 'Roles', icon: 'roles', route: '/roles', permission: 'role.list' },
        { label: 'Permissions', icon: 'permission', route: '/permissions', permission: 'permission.list' },
        { label: 'Devices', icon: 'device', route: '/devices', permission: 'device.list' },
        { label: 'AI Templates', icon: 'frame', route: '/ai-templates', permission: 'ai-template.list' },
      ]
    },
    {
      title: 'Catalog',
      items: [
        { label: 'Products', icon: 'product', route: '/products', permission: 'product.list' },
        { label: 'Services', icon: 'service', route: '/services', permission: 'service.list' },
        { label: 'Frames', icon: 'frame', route: '/frames', permission: 'frame.list' },
        { label: 'Addons', icon: 'addons', route: '/addons', permission: 'product-addon.list' },
        { label: 'Promos', icon: 'order', route: '/promos', permission: 'promo.list' },
        { label: 'Vouchers', icon: 'order', route: '/vouchers', permission: 'voucher.list' },
      ]
    },
    {
      title: 'Transactions',
      items: [
        { label: 'Orders', icon: 'order', route: '/orders', permission: 'order.list' },
        { label: 'Order Services', icon: 'service', route: '/order-services', permission: 'order-service.list' },
        { label: 'Order Addons', icon: 'addons', route: '/order-addons', permission: 'order-addon.list' },
        { label: 'Photo Sessions', icon: 'frame', route: '/photo-sessions', permission: 'photo-session.list' },
      ]
    }
  ];

  visibleMenuSections: MenuSection[] = [];
  private authSubscription!: Subscription;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authSubscription = this.authService.currentUser$.subscribe(() => {
      this.updateMenuVisibility();
    });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  updateMenuVisibility(): void {
    this.visibleMenuSections = this.menuSections.map(section => {
      const filteredItems = section.items.filter(item => {
        if (!item.permission) {
          return true; // No permission required
        }
        return this.authService.hasPermission(item.permission);
      });
      return { ...section, items: filteredItems };
    }).filter(section => section.items.length > 0);
  }

  toggle(): void {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }

  isActive(route: string): boolean {
    return this.router.url === route || this.router.url.startsWith(route + '/');
  }

  logout(): void {
    this.authService.logout();
  }
}
